<template>
    <form-row title='Contract "Binding" Acceptance Date' section_id="contract-acceptance">
        <div class="w-1/2">
            <input-date
                name="contract_acceptance_date"
                v-model="contract_acceptance_date"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        property: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            test: store.state.contract_acceptance_date,
        }
    },

    computed: {
        contract_acceptance_date: {
            get() {
                return store.state.contract_acceptance_date;
            },
            set(val) {
                store.state.contract_acceptance_date = val;
            },
        },
    },
}
</script>
